<template>
	<div>
		<a-page-header style="background: #fff;" title="天天特价商品管理" :breadcrumb="{props:{routes:[{breadcrumbName:'首页'},{breadcrumbName:'天天特价商品管理'}]}}">
			<template slot="extra">
				<a-button type="primary" @click="addSaleGoodsModal = true">
					添加特价商品
				</a-button>
			</template>
			<a-form-model layout="inline" :form="searchForm" @submit="searchSubmit">
				<a-form-model-item>
					<a-input style="width: 300px" placeholder="请输入商品名称" v-model="searchForm.word" />
				</a-form-model-item>
				<!-- <a-form-model-item>
					<a-cascader :options="goodsClassList" placeholder="商品分类" v-model="searchForm.goodsClass" />
				</a-form-model-item> -->
				<a-form-model-item>
					<a-button type="primary" html-type="submit">
						搜索
					</a-button>
				</a-form-model-item>
			</a-form-model>
		</a-page-header>

		<!-- 列表 -->
		<div class="mainBox">
			<div class="contentBox">
				<a-table :columns="columns" :dataSource="list" rowKey="id" :pagination="pagination" :loading="loading" @change="handleTableChange">
					<span slot="goodsThumb" slot-scope="goodsThumb">
						<a-avatar shape="square" :src="goodsThumb" :size="70" />
					</span>
					<span slot="openDate" slot-scope="text,openDate">
						<a-tag color="green" v-for="item in openDate.dataArr" :key="item">{{item}}</a-tag>
					</span>
					<span slot="goodsPrice" slot-scope="text,goodsPrice">
						<span style="font-weight: 700;margin-right: 20px;font-size: 20px;">{{goodsPrice.saleGoodsPrice}} 元</span>
						<span style="text-decoration:line-through;color: #8c8c8c;margin-right: 18px;">{{goodsPrice.goodsPrice}} 元</span>
						<span style="margin-right: 20px;">限购 {{goodsPrice.saleGoodsInventory}} {{goodsPrice.goodsUnit}}</span>
						<span style="">送积分 {{goodsPrice.saleGoodsIntegral}}</span>
					</span>
					<span slot="action" slot-scope="text, record">
						<a @click="toDetail(record.id)">详情</a>
						<a-divider type="vertical" />
						<a-popconfirm title="请确认是否删除？" okText="是" cancelText="否" @confirm="del(record.id)">
							<a href="javascript:;" style="color: #ff4d4f;">删除</a>
						</a-popconfirm>
					</span>
				</a-table>
			</div>
		</div>

		<!-- 添加特价商品 -->
		<a-modal title="添加特价商品" v-model="addSaleGoodsModal" @ok="addSaleGoodsSubmit" cancelText="取消" okText="添加" width="50%">
			<a-form-model ref="addSaleGoodsForm" :model="addSaleGoodsForm" :rules="addSaleGoodsFormRules" :label-col="{ span: 8 }"
			 :wrapper-col="{ span: 10 }">
				<a-form-model-item label="选择商品" prop="saleGoodsId">
					<a-select :options="goodsList" placeholder="请选择特价商品" v-model="addSaleGoodsForm.saleGoodsId" @select="goodsChange" />
				</a-form-model-item>
				<a-form-model-item :wrapper-col="{ span: 10, offset: 8 }" v-if="goodsDetail">
					<div style="display: flex;justify-content: space-between;background: #d9f7be;padding:20px;border-radius: 20px;">
						<div>
							<div><span style="color: #8c8c8c;">商品名称</span> {{goodsDetail.goodsName}}
								<a-tag color="blue">{{goodsDetail.className}}</a-tag>
							</div>
							<div><span style="color: #8c8c8c;">库存</span> {{goodsDetail.goodsInventory}} {{goodsDetail.goodsUnit}}</div>
							<div><span style="color: #8c8c8c;">售价</span> {{goodsDetail.goodsPrice}} 元</div>
						</div>
						<div>
							<a-avatar shape="square" :src="goodsDetail.goodsThumb" :size="70" />
						</div>
					</div>
				</a-form-model-item>
				<a-form-model-item label="特价价格" prop="saleGoodsPrice">
					<a-input-number :min="0" v-model="addSaleGoodsForm.saleGoodsPrice" style="width: 150px;" /> 元
				</a-form-model-item>
				<a-form-model-item label="特价总限购" prop="saleGoodsInventory">
					<a-input-number :min="0" style="width: 150px;" :max="goodsDetail.goodsInventory" v-model="addSaleGoodsForm.saleGoodsInventory" />
					{{goodsDetail.goodsUnit}}
				</a-form-model-item>
				<a-form-model-item label="每人限购" prop="saleGoodsEvery">
					<a-input-number :min="0" style="width: 150px;" :max="goodsDetail.goodsInventory" v-model="addSaleGoodsForm.saleGoodsEvery" />
					{{goodsDetail.goodsUnit}}
				</a-form-model-item>
				<a-form-model-item label="送积分" prop="saleGoodsIntegral">
					<a-input-number :min="0" style="width: 150px;" v-model="addSaleGoodsForm.saleGoodsIntegral" /> 积分
				</a-form-model-item>
				<a-form-model-item label="上架日期" prop="saleGoodsDate">
					<a-range-picker :locale="locale" v-model="addSaleGoodsForm.saleGoodsDate" format="YYYY-MM-DD" />
				</a-form-model-item>
			</a-form-model>
		</a-modal>
	</div>
</template>

<script>
	import moment from "moment"
	import 'moment/locale/zh-cn'
	import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
	const columns = [{
			title: 'ID',
			dataIndex: 'id',
		},
		{
			title: '特价商品名称',
			dataIndex: 'goodsName',
			scopedSlots: {
				customRender: 'goodsName'
			},
		},
		{
			title: '缩略图',
			dataIndex: 'goodsThumb',
			scopedSlots: {
				customRender: 'goodsThumb'
			},
		},
		{
			title: '售价',
			dataIndex: 'goodsPrice',
			scopedSlots: {
				customRender: 'goodsPrice'
			},
		},
		{
			title: '开放时间',
			dataIndex: 'openDate',
			width:'40%',
			scopedSlots: {
				customRender: 'openDate'
			},
		},
		{
			title: '销量',
			dataIndex: 'saleGoodsSales',
			scopedSlots: {
				customRender: 'saleGoodsSales'
			},
		},
		{
			title: '操作',
			dataIndex: 'action',
			scopedSlots: {
				customRender: 'action'
			},
		},
	];

	export default {
		data() {
			return {
				moment,
				locale,
				columns,
				goodsDetail: '',
				list: [],
				goodsList: [],
				searchForm: {},
				pagination: {
					pageSize: 20,
					total: 0,
					current: 1
				},
				loading: false,
				addSaleGoodsModal: false,
				addSaleGoodsForm: {},
				addSaleGoodsFormRules: {
					saleGoodsId: [{
						required: true,
						message: '请选择特价商品',
						trigger: 'change'
					}],
					saleGoodsPrice: [{
						required: true,
						message: '请填写特价价格',
						trigger: 'blur'
					}],
					saleGoodsInventory: [{
						required: true,
						message: '请填写特价总限购',
						trigger: 'blur'
					}],
					saleGoodsEvery: [{
						required: true,
						message: '请填写每人限购',
						trigger: 'blur'
					}],
					saleGoodsDate: [{
						required: true,
						message: '请选择上架日期',
						trigger: 'change'
					}],
				},
			};
		},

		mounted() {
			this.getList()
			this.getGoodsList()
		},

		methods: {
			goodsChange(id) {
				this.$http.post('/admin/index.php/admin/Shop/goodsInfo', {
					id: id
				}).then((res) => {
					if (res.data.code == 1) {
						this.goodsDetail = res.data.data
					}
				})
			},
			
			addSaleGoodsSubmit() {
				this.$http.post('/admin/index.php/admin/Shop/specialSave', {
					saleGoodsId: this.addSaleGoodsForm.saleGoodsId,
					saleGoodsPrice: this.addSaleGoodsForm.saleGoodsPrice,
					saleGoodsInventory: this.addSaleGoodsForm.saleGoodsInventory,
					saleGoodsEvery: this.addSaleGoodsForm.saleGoodsEvery,
					saleGoodsIntegral: this.addSaleGoodsForm.saleGoodsIntegral,
					saleGoodsBegin: moment(this.addSaleGoodsForm.saleGoodsDate[0]).format('YYYY-MM-DD'),
					saleGoodsEnd: moment(this.addSaleGoodsForm.saleGoodsDate[1]).format('YYYY-MM-DD'),
				}).then((res) => {
					if (res.data.code == 1) {
						this.$message.success(res.data.msg);
						this.addSaleGoodsModal = false
						this.getList()
					} else {
						this.$message.error(res.data.msg);
					}
				})

			},

			toDetail(id) {
				this.$router.push('/saleGoods/saleGoodsDetail?id=' + id)
			},

			del(id) {
				this.$http.post('/admin/index.php/admin/Shop/specialDel', {
					id: id
				}).then((res) => {
					if (res.data.code == 1) {
						this.$message.success(res.data.msg);
						this.getList();
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},

			searchSubmit(e) {
				e.preventDefault()
				this.getList()
			},

			handleTableChange(pagination, filters, sorter) {
				this.list = []
				this.pagination.current = pagination.current
				this.pagination.field = sorter.field
				this.pagination.order = sorter.order
				this.getList()
			},

			getList() {
				this.loading = true
				var data = {
					page: this.pagination.current,
					num: this.pagination.pageSize,
					field: this.pagination.field,
					order: this.pagination.order,
					word: this.searchForm.word,
					housetypeHouse: this.searchForm.housetypeHouse
				}
				this.$http.post('/admin/index.php/admin/Shop/specialList', data).then(res => {
					this.loading = false
					if (res.data.code == 1) {
						this.list = res.data.data
						this.pagination.total = res.data.count
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},

			getGoodsList() {
				this.$http.get('/admin/index.php/admin/Shop/goodsPullList').then(res => {
					if (res.data.code == 1) {
						this.goodsList = res.data.data
					}
				})
			}
		}
	}
</script>

<style scoped="">
	.ant-upload-select-picture-card i {
		font-size: 32px;
		color: #999;
	}

	.ant-upload-select-picture-card .ant-upload-text {
		margin-top: 8px;
		color: #666;
	}
</style>
